module.exports = __webpack_public_path__ + "media/PAG84-05.4901ce04.mp3";